export const REPORTS_META = {
  "daily-personal-horoscope": {
    type: "daily-personal-horoscope",
    title: "Daily Personal Horoscope",
    price: 9,
    sections: [
      "Today's Planetary Energy & Mood",
      "Your Focus Areas for the Day",
      "Hidden Opportunities & Risks",
      "Favourable Time Slots (Muhurta)",
      "Do's, Don'ts & Daily Remedy"
    ],
  },
  "love-compatibility": {
    type: "love-compatibility",
    title: "Love Compatibility",
    price: 29,
    sections: [
      "How the Stars See You Both",
      "Emotional, Physical & Mental Sync",
      "Strengths of Your Relationship",
      "Warning Signs & Red Flags",
      "Marriage Possibility & Longevity",
      "Karmic Ties & Past-Life Connection",
      "How to Nurture the Bond (Remedies)"
    ],
  },
  "career-forecast": {
    type: "career-forecast",
    title: "Career Growth Forecast",
    price: 29,
    sections: [
      "Your Current Career Vibration",
      "Planetary Influences on Ambition & Effort",
      "Next 12 Months: Growth & Turning Points",
      "Career Blocks: What’s Holding You Back?",
      "Foreign Opportunities, Job Changes or Promotions?",
      "Ideal Industries & Roles Based on Your Chart",
      "Career-Boosting Remedies & Guidance"
    ],
  },
  "financial-outlook": {
    type: "financial-outlook",
    title: "Financial Outlook",
    price: 29,
    sections: [
      "How Your Chart Handles Money",
      "Upcoming High & Low Phases in Income",
      "Spending Habits & Wealth Leaks",
      "Savings, Investments & Asset Potential",
      "Luck with Speculation or Windfalls?",
      "Caution Periods for Financial Risks",
      "Money Magnet Remedies (Mantras, Gemstones)"
    ],
  },
  "marriage-timing": {
    type: "marriage-timing",
    title: "Marriage Timing & Chances",
    price: 29,
    sections: [
      "Is Marriage Promised in Your Chart?",
      "Strong Time Windows for Marriage",
      "Delay Factors or Blockages (If Any)",
      "Love vs Arranged: What Suits You More?",
      "Qualities of Your Future Partner",
      "Possibility of Multiple Relationships",
      "Marriage Remedies to Activate Timing"
    ],
  },
  "health-wellness": {
    type: "health-wellness",
    title: "Health & Wellness",
    price: 29,
    sections: [
      "Your Body’s Natural Strengths & Weaknesses",
      "Prone Areas: Chronic or Lifestyle Conditions",
      "Upcoming Sensitive Periods for Health",
      "Mental Health, Sleep & Stress Planets",
      "Spiritual Health: Aura, Energy, Balance",
      "Natural Remedies Based on Your Chart (Ayurvedic/Yogic)"
    ],
  },
  "childbirth-predictions": {
    type: "childbirth-predictions",
    title: "Childbirth Predictions",
    price: 29,
    sections: [
      "Childbirth Promise in Your Chart",
      "Best Periods for Conception & Fertility",
      "Delays, Miscarriage Risks or IVF Possibility",
      "Number of Children & Gender Tendencies",
      "Spiritual Bond with Future Child",
      "Remedies to Support Fertility & Parenthood"
    ],
  },
  "job-vs-business": {
    type: "job-vs-business",
    title: "Job vs Business Report",
    price: 29,
    sections: [
      "Which Path Is Stronger in Your Chart?",
      "Planetary Support for Risk vs Stability",
      "Success Vibes in Corporate/Startup Setup",
      "Is Partnership Favourable?",
      "Timing to Switch or Start Something New",
      "Karma-Linked Career Advice",
      "Remedies to Strengthen Chosen Path"
    ],
  },
  "personality-report": {
    type: "personality-report",
    title: "Personality Deep-Dive",
    price: 29,
    sections: [
      "Your Core Nature & Emotional Style",
      "How You Think, Express & Connect",
      "Subconscious Drives & Karmic Patterns",
      "How Others Perceive You",
      "Decision-Making, Leadership & Confidence",
      "Personality Growth Remedies (Mantra, Yoga, Colors)"
    ],
  },
  "planetary-transits": {
    type: "planetary-transits",
    title: "Transit Impact Report",
    price: 29,
    sections: [
      "Which Planets Are in Motion Right Now?",
      "How Each Transit Affects You Personally",
      "Key Areas of Impact (Career, Love, Health, etc.)",
      "High Vibration & Low Vibration Periods",
      "What to Do & Avoid During This Time",
      "Transit Remedies (Puja, Fasting, Chanting)"
    ],
  },
};
